import axios from 'axios'
import qs from 'qs'
export default {
    ajax(action, params= null) {
        let url = '/index.php?ajax'
        let data = {
            sf_action: action,
            sf_action_data: qs.stringify(params),
            sf_vue_request: true
        }
        let options = {
            validateStatus: (status) => status >= 200 && status < 300,
        }
        return axios.post(url, qs.stringify(data), options)
    }
}
